import { render, staticRenderFns } from "./ViewDetail.vue?vue&type=template&id=b3b0088e&scoped=true"
import script from "./ViewDetail.vue?vue&type=script&lang=js"
export * from "./ViewDetail.vue?vue&type=script&lang=js"
import style0 from "./ViewDetail.vue?vue&type=style&index=0&id=b3b0088e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b0088e",
  null
  
)

export default component.exports